import { Button } from '@welbe/design-system';
import React from 'react';
import { ReactComponent as MailIcon } from './assets/mail-icon.svg';
import {
	Container,
	ContainerButtons,
	Description,
	Subtitle,
	Title,
} from './OcupationalDoctor.styles';
import { useSendRefers } from '../../ReferModalFlow.hooks';

interface OcupationalDoctorProps {
	selectedEmployees: any;
	onCancel: () => void;
	amount: number;
	onNoDoctors: () => void;
	selectedCommunication: any;
	onSuccess: () => void;
	onSaveResults: (e: any) => void;
}

export const OcupationalDoctor = ({
	selectedEmployees,
	onCancel,
	amount,
	onNoDoctors,
	selectedCommunication,
	onSuccess,
	onSaveResults,
}: OcupationalDoctorProps): JSX.Element => {
	const isAllEmployees = Boolean(!selectedEmployees.length && amount);

	const { sendRefers, isLoading } = useSendRefers({
		selectedEmployees,
		onNoDoctors,
		selectedCommunication,
		onSuccess,
		onSaveResults,
		isAllEmployees,
	});

	return (
		<Container>
			<Title>Referir colaboradores</Title>
			<Subtitle>{`${amount} colaboradores seleccionados`}</Subtitle>
			<MailIcon />
			<Description>
				Al referir envirás una invitación para que el colaborador agende una
				cita con el médico del trabajo.
			</Description>
			<ContainerButtons>
				<Button variant="outline" onClick={onCancel}>
					Cancelar
				</Button>
				<Button onClick={sendRefers} loading={isLoading}>
					Referir
				</Button>
			</ContainerButtons>
		</Container>
	);
};
